/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import { Box } from "@mui/material";
import PatientHubDataContent from "components/content/PatientHubDataContent";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";
import { useLocation } from "react-router-dom";

/**
 * Props for PatientHubPage component.
 */
interface PatientHubPageInterface {
  patientId?: string;
}

/**
 * Comprehensive patient information hub page.
 * 
 * Features:
 * - Complete patient medical record overview
 * - Tabbed interface for demographics, insurance, appointments, encounters
 * - Medical history and allergies
 * - Medication list and prescriptions
 * - Lab results and imaging reports
 * - Billing and payment history
 * - Document management (uploaded files, consents)
 * - Quick actions (schedule appointment, create encounter, send message)
 * 
 * The page accepts patient ID via props or navigation state.
 * 
 * @param patientId - Optional patient ID passed as prop
 * @returns Patient hub page component
 */
const PatientHubPage: React.FC<PatientHubPageInterface> = ({ patientId }) => {
  const location = useLocation();
  const state = (location.state as { data?: string }) || {};
  const patientData = state.data || null;

  const patient = patientData || patientId || null;

  return (
    <DefaultDashboardLayout>
      <Box>
        <PatientHubDataContent patientId={patient} />
      </Box>
    </DefaultDashboardLayout>
  );
};

export default PatientHubPage;

